import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { UserAuthorizationService } from '../services/user-authorization.service';
import { AuthGuard } from './auth-guard.service';

@Injectable({
    providedIn: 'root'
})
export class StaffAuthGuard extends AuthGuard implements CanActivate {
    constructor(private router: Router, authService: UserAuthorizationService) {
        super(authService);
    }

    public override async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const isLoggedIn = await super.ensureUserIsLoggedIn(state);
        if (!isLoggedIn) return false;

        return this.ensureUserIsStaff();
    }

    private async ensureUserIsStaff(): Promise<boolean> {
        const user = await this.authService.user;

        if (user && user.isStaffOrAdmin()) return true;

        // redirect to home
        await this.router.navigateByUrl('/');
        return false;
    }
}